import * as types from './types';
import { createToast, toastType } from '../../../common/ToastHelper';

export const getBillingAccountListAction = site => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(loadingTableAction(true));
    MPWWebApi.getGeneric(`student/BillingAccountList/${site}`)
      .then(response => {
        dispatch({
          type: types.GET_BILLING_DETAILS_LIST,
          payload: response,
        });
        dispatch(loadingTableAction(false));
        if (response.data.Data === null) {
          createToast(toastType.info, 'Results', 'No data found!', true);
        }
      })
      .catch(error => {
        dispatch({
          type: types.GET_BILLING_DETAILS_LIST_ERROR,
          payload: error.response,
        });
        dispatch(loadingTableAction(false));
        if (error.response.data.Errors[0].Title === null) {
          createToast(
            toastType.error,
            'Error',
            'Unable to load students',
            true
          );
        } else {
          createToast(
            toastType.error,
            error.response.data.Errors[0].Title,
            error.response.data.Errors[0].Message,
            true
          );
        }
      });
  };
};

export const billingReportListAction = data => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(loadingReportAction(true));
    MPWWebApi.postGenericInsertUpdate('reports/BillingAccountList', data)
      .then(response => {
        dispatch({
          type: types.GET_BILLING_REPORTS_LIST,
          payload: response,
        });
        dispatch(loadingReportAction(false));
        if (response.data.Data === null || response.data.Data === '') {
          createToast(toastType.info, 'Results', 'No data found!', true);
        }
      })
      .catch(error => {
        dispatch({
          type: types.GET_BILLING_REPORTS_LIST_ERROR,
          payload: error.response,
        });
        dispatch(loadingReportAction(false));
        if (error.response.data.Errors[0].Title === null) {
          createToast(toastType.error, 'Error', 'Unable to view report', true);
        } else {
          createToast(
            toastType.error,
            error.response.data.Errors[0].Title,
            error.response.data.Errors[0].Message,
            true
          );
        }
      });
  };
};

export const billingReportDetailAction = data => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(loadingReportAction(true));
    MPWWebApi.postGenericInsertUpdate('reports/BillingAccountDetail', data)
      .then(response => {
        dispatch({
          type: types.GET_BILLING_REPORTS_DETAILS,
          payload: response,
        });
        dispatch(loadingReportAction(false));
        if (response.data.Data === null || response.data.Data === '') {
          createToast(toastType.info, 'Results', 'No data found!', true);
        }
      })
      .catch(error => {
        dispatch({
          type: types.GET_BILLING_REPORTS_DETAILS_ERROR,
          payload: error.response,
        });
        dispatch(loadingReportAction(false));
        if (error.response.data.Errors[0].Title === null) {
          createToast(toastType.error, 'Error', 'Unable to view report', true);
        } else {
          createToast(
            toastType.error,
            error.response.data.Errors[0].Title,
            error.response.data.Errors[0].Message,
            true
          );
        }
      });
  };
};

const loadingReportAction = status => {
  return {
    type: types.BILLING_REPORT_LOAD,
    payload: status,
  };
};

const loadingTableAction = status => {
  return {
    type: types.STUDENT_DATA_LOAD,
    payload: status,
  };
};

export const checkAll = (checkAll, currentRows) => {
  return {
    type: types.BILLING_CHECKALL,
    payload: { checkAll, currentRows },
  };
};

export const updateBillingData = item => {
  return {
    type: types.UPDATE_BILLING_DATA_CHECK,
    payload: item,
  };
};

export const clearDetailReportDataAction = () => {
  return {
    type: types.CLEAR_DETAIL_REPORT,
  };
};

export const clearListReportDataAction = () => {
  return {
    type: types.CLEAR_LIST_REPORT,
  };
};



// WEBPACK FOOTER //
// ./src/pages/billingaccount/state/actions.js